import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI()
export default class InstagramAPI {

    URI_V1 = "/v1/instagram"

    saveInstaTemplateConfig = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/template-config?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };

    getInstaTemplateConfig = async () => {
        return await apiService.get(`${this.URI_V1}/template-config?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    generateReels = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/reels-generate?companyId=${companyAPI.getCompanyManagment().id}`, data);
    };
    
    getReelsConfig = async () => {
        return await apiService.get(`${this.URI_V1}/reels-config?companyId=${companyAPI.getCompanyManagment().id}`);
    };

    getAllReels = async () => {
        return await apiService.get(`${this.URI_V1}/reels-history?companyId=${companyAPI.getCompanyManagment().id}`);
    };
}
